import {FieldType} from "../../fields3/field-type";
import FieldsCollection from "../../fields3/collection/base/fields-collection";
import {EntityType} from "../../gd/const/item";
import FieldString from "../../fields3/generic/string/string";

const baseConfig = [
    {
        fieldId : 'label',
        label   : 'Label',
        type    : FieldType.STRING
    },
    {
        fieldId : 'url',
        label   : 'URL',
        type    : FieldType.STRING
    }
]

export default class LinkFields extends FieldsCollection {

    constructor() {
        super(baseConfig, EntityType.DYNAMIC_MODEL)
    }

    get label() { return this.get('label') as FieldString }
    get url() { return this.get('url') as FieldString }

}
